import s1 from "../swiper/s1.jpg"
import s2 from "../swiper/s2.jpg"
import s3 from "../swiper/s3.png"
import s4 from "../swiper/s4.png"
import s5 from "../swiper/s5.jpeg"
import cartImg from "../swiper/3385483.webp"
export const final = {
    s1,
    s2,
    s3,
    s4,
    s5,
    cartImg,
}